import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { modernizationPageMeta, modernizationSchema } from 'components/common/schema'
import Template from 'components/services/modernization'

const Modernization: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...modernizationPageMeta} />
      <JsonLd data={modernizationSchema} />
      <Template />
    </>
  )
}

export default Modernization
